// src/AuthGuard.jsx or .tsx
import { useEffect, useState } from "react";
import { useLocation, useNavigate, Outlet } from "react-router-dom";
import { validateToken } from "./authUtils"; 
import ProtectedShell from "../Components/ProtectedShell.jsx";
import { clearAuthSession } from "./authSession.js";
import RouteFallback from "../Components/RouteFallback.jsx";

const AuthGuard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    let isActive = true;

    const checkAuth = async () => {
      try {
        const valid = await validateToken();
        if (!isActive) return;

        if (valid && location.pathname === "/") {
          navigate("/home-page-customer", { replace: true });
        }

        if (!valid && location.pathname !== "/SignUp") {
          clearAuthSession();
          navigate("/", { replace: true });
        }
      } catch (error) {
        console.error('Auth validation failed:', error);
        if (location.pathname !== "/SignUp") {
          clearAuthSession();
          navigate("/", { replace: true });
        }
      } finally {
        if (isActive) {
          setCheckingAuth(false);
        }
      }
    };

    checkAuth();
    return () => {
      isActive = false;
    };
  }, [location.pathname, navigate]);

  if (checkingAuth) {
    return <RouteFallback title="Checking session" message="Please wait while we verify your account and load the app." />;
  }

  return (
    <ProtectedShell>
      <Outlet />
    </ProtectedShell>
  );
};

export default AuthGuard;
